import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {getCurrentFabricatorName} from "../../../../utilities";

const WizardClonePopupTitle = (props) => {

  const {intl, currentFabricatorName, wizardList} = props;

  const selectedWizards = wizardList.filter(wizardItem => wizardItem.selected);

  return (
    <div className="ui-popup__header">
      <span className="ui-popup__header-title text-left">
        <FormattedMessage id="wizard.popup.title.clone" values={{
          wizardName: selectedWizards.length === 1
            ? selectedWizards[0].name
            : selectedWizards.length + " " + intl.formatMessage({id: "wizard.popup.title.clone.wizards"})
        }}/>
        {" " + currentFabricatorName}
      </span>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardVisualizer} = store.wizardState;
  return {
    wizardList: wizardList.filter(wizardItem => wizardItem.visualizer === wizardVisualizer),
    currentFabricatorName: getCurrentFabricatorName(store)
  };
};


export default injectIntl(
  connect(mapStateToProps)(WizardClonePopupTitle)
)
